window.globalIdCounter = -1;

export const generateTemporaryId = () => {
    return window.globalIdCounter--;
}